import { flow, getRoot, types } from 'mobx-state-tree';
import { CmsApi, CoreApi } from 'service/axios-api';
import { IRootStore } from './root';
import { LocField } from './localizations/umbraco';
import { NexonlinkRegion } from 'types/enum';

const { application, settings } = window;

const RegionConfigStore = types
    .model('RegionConfigStore', {
        termsOfUseLink: types.optional(LocField, {}),
        privacyPolicyLink: types.optional(LocField, {}),
        supportLink: types.optional(LocField, {}),
        accountHost: types.optional(types.string, `${settings.hosts.accounts}/account/`),
        walletHost: types.optional(types.string, `${settings.hosts.accounts}/wallet/`),
        // cdnHost: types.optional(types.string, settings.hosts.cdn),
        code: application.params.region as string,
        ipMembershipNo: 0,
        isVietnam: false,
        countryInfo: 'US',
    })
    .views((self) => {
        const views = {
            get root(): IRootStore {
                return getRoot<IRootStore>(self);
            },
            get cmsCode() {
                if (self.code === '5') {
                    return self.isVietnam ? '51' : '5';
                }
                return self.code;
            },
            get cmsWebCode() {
                switch (self.code) {
                    case '1':
                        return 'global';
                    case '3':
                        return 'th';
                    case '4':
                        return 'tw';
                    case '5':
                        return self.isVietnam ? 'vietnam' : 'sea';
                    default:
                        return 'global';
                }
            },
            get cdnHost() {
                if (views.root.session.isPreview) return 'https://pre-nxl.nxfs.nexon.com';
                return settings.hosts.cdn;
            },
            get nexonlinkRegion() {
                switch (self.code) {
                    case '1':
                        return NexonlinkRegion.WEST;
                    case '3':
                        return NexonlinkRegion.TH;
                    case '4':
                        return NexonlinkRegion.TW;
                    case '5':
                        // TODO: 베트남 별도 처리 필요할지 추후 서비스 확대 시 확인 필요
                        return self.isVietnam ? NexonlinkRegion.WEST : NexonlinkRegion.SEA;
                    default:
                        return NexonlinkRegion.WEST;
                }
            },
            get isTW() {
                return self.code === '4';
            },
        };
        return views;
    })
    .views((self) => ({
        get loginLink() {
            return `${self.accountHost}${self.root.systemInfo.lang}/login`;
        },
        get walletLink() {
            return `${self.walletHost}${self.root.systemInfo.lang}`;
        },
    }))
    .actions((self) => ({
        fetchCmsCode: flow(function* () {
            const {
                data: { country, isVietnam, membershipNo },
            }: { data: { country: string; isVietnam: boolean; membershipNo: number } } = yield CoreApi.get(
                '/country-membership/v1/no-auth/membership-no'
            );
            if (application.params.region === '5') {
                self.isVietnam = isVietnam;
                self.ipMembershipNo = membershipNo;
            }
            self.countryInfo = country;
        }),
        fetch: flow(function* () {
            const data: any = yield CmsApi.get('/frontend/v3/{regionWebCode}/config.json');
            self.termsOfUseLink.data = data.termsOfUseLink;
            self.privacyPolicyLink.data = data.privacyPolicyLink;
            self.supportLink.data = data.supportLink;
            // self.accountHost = data.host.accounts;
            // self.walletHost = data.host.billing;
        }),
        isKd(productId: string) {
            return ['50203'].includes(productId);
        }
    }));

export default RegionConfigStore;
